import Vue from 'vue';
import store from './../../store';
import clientTransformer from './../../transformers/client';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

/* eslint no-console: ["error", { allow: ["log", "error"] }] */
const success = ({ data }, resolve) => {
  const clients = clientTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchClients', { clients, pagination });
  resolve({ clients, pagination });
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/clients', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/items.js